<template>
  <div>
    <div>
      HELLO WORLD MEDICAL WRITING
    </div>

  </div>
</template>

<script>

export default {
  name: 'MedicalWriting',
  components: {

  },
  data () {
    return {

    }
  },
  /// ////
  computed: {

  },
  /// ////
  mounted: function () {

  },
  /// ////
  methods: {
    showModal () {
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
    }

  }
}

</script>
<style>

</style>
